module.exports = __webpack_public_path__ + "media/images/remove_fees-c5f504e1.svg";